export type ModalVariant = 'winners' | 'advisory';

export interface PersonData {
  id: number;
  name: string;
  role: string;
  photo: string;
  photoModal?: string;
  bio: string;
}

// ── Winners ─────────────────────────────────────────────────────────────────
export const WINNERS: PersonData[] = [
  {
    id: 0,
    name: 'MAPPA',
    role: '',
    photo: './assets/winners/winners-01.webp',
    photoModal: './assets/winners/winners-01-modal.webp',
    bio: '2011年設立のアニメーションスタジオ。テレビアニメを中心に、映画、CM、Webムービー等、ジャンルにとらわれない様々な映像作品の企画・制作を行っている。自社で権利を保有するIPの窓口権を運用し、国内外でのライツ事業も展開。代表作は、『呪術廻戦』『「進撃の巨人」The Final Season』『チェンソーマン』ほか。',
  },
  
  {
    id: 1,
    name: 'ハタノ ワタル',
    role: '紙漉キハタノ代表',
    photo: './assets/winners/winners-04.webp',
    bio: '多摩美術大学絵画科油画専攻を卒業後、京都・黒谷和紙の研修生として和紙づくりを学び、2000年に黒谷和紙の漉き師として独立。2007年には京もの認定工芸師に認定。2018年に「紙漉キハタノ」を設立。和紙職人として原料となる楮（こうぞ）の栽培から紙漉きまでを手がける一方、和紙を用いたアート作品やプロダクトの制作、建築・空間の施工にも携わる。伝統技術を受け継ぎながら、紙の素材や質感を生かした表現を探求し現代の暮らしや空間へつなぐ活動を続ける。さらに若いつくり手が黒谷和紙の可能性を探る「午後二時設計室」を立ち上げ、組織化やネット販売、海外展開も進めている。',
  },
  
  {
    id: 2,
    name: '岡 雄大',
    role: 'Staple 代表取締役／GOOD SOIL代表取締役',
    photo: './assets/winners/winners-03.webp',
    bio: '大学卒業後、Starwood Capital Groupに入社し、東京とサンフランシスコで不動産投資などに従事。その後シンガポールで独立し、Aman Resortsなどホテルブランドの投資アドバイザリーを手がけた。2018年にStapleを創業。現在は広島・瀬戸田をはじめ全国各地で、ホテルを起点とした地域開発を展開。不動産ファンド、開発、設計・デザイン、ホテルや飲食店の運営、地域イベントまでを横断し、経済資本、文化資本、自然資本の好循環を生み出しながら、その土地に根づく生活文化を未来へつなぐことを目指している。',
  },
  
  {
    id: 3,
    name: '山田 萌',
    role: 'KIMONO MOM FOUNDER & CEO／動画クリエイター',
    photo: './assets/winners/winners-05.webp',
    bio: '京都出身。16歳で舞妓の道に入り、その後芸妓として活動。長女の出産後、2020年に「KIMONO MOM」としてYouTubeを始め、着物姿で日本の家庭料理を紹介する動画が人気に。チャンネル登録者数は318万人を超える。海外の視聴者から寄せられる声をきっかけに、22年には夫と起業し、万能調味料「UMAMI SAUCE」を開発。24年に発売後、米国で現地生産体制を整え、Whole Foods Marketなど全米約4,000の小売店へ販路を拡大した。現在はロサンゼルスを拠点に、動画とプロダクトの両面から、日本の味や食文化を海外の日常へ届けている。',
  },
  
  {
    id: 4,
    name: '千木良 卓也',
    role: 'クラウドナイン 代表取締役社長',
    photo: './assets/winners/winners-02.webp',
    bio: '1984年生まれ。美容業界を経て2014年に音楽業界に参入。同年ハイスピードボーイに入社しGReeeeN（現GRe4N BOYZ）のマネージャーを4年間務める。その後1年間フリーのプロデューサーを経験し19年にクラウドナインを創業。同社には、Ado、shallm、平手友梨奈などアーティストやクリエイターが所属する。26年5月には米国でAdoや新しい学校のリーダーズ、 ちゃんみななど日本人アーティスト7組が出演する音楽フェス「Zipangu」を主催し約2万人の観客を集めた。リスクも多い海外市場で先陣を切って興行を成功させ、日本のアーティストが世界進出をするための足場づくりを進めている。',
  },
  
  {
    id: 5,
    name: 'ドズル',
    role: 'ドズル代表取締役／ゲーム実況者',
    photo: './assets/winners/winners-28.webp',
    bio: '医大生時代にゲーム実況を始め、2016年に会社を設立。5人組ゲーム実況グループ「ドズル社」のリーダーとして、YouTube配信を軸に、グッズ、ライセンス、イベントへ事業を展開。登録者数280万人超、総視聴回数74億回超。100人以上の制作体制を築き、企画開発や組織づくりを推進。2026年5月にはクリエイター事務所「WONDER DIVE」を新設し、若手実況者の育成に乗り出した。Minecraftを中心に、オリジナルゲーム開発や海外展開も視野に入れ、ゲーム実況文化を次世代へつなぐ仕組みづくりに取り組む。',
  },
  
  {
    id: 6,
    name: '林 健太郎',
    role: 'NOTHING NEW 代表取締役／映画プロデューサー',
    photo: './assets/winners/winners-06.webp',
    bio: '東宝勤務を経て、2022年に映画会社「NOTHING NEW」を創業。「才能が潰されない世の中」を掲げ、企画・製作から宣伝、配給、海外展開までを一貫して担うことで、実績のない新人にも「打席」をつくっている。「日常の中にある恐怖」を追求した映画『チルド』（監督：岩崎裕介）はベルリン国際映画祭で国際批評家連盟賞を受賞。今秋公開の長編アニメ『我々は宇宙人』（監督：門脇康平）もカンヌ国際映画祭に選出された。作家独自の表現やこだわりを尊重しながら、小さな世界に閉じ込めず、広く観客へ届ける道を切り拓いている。',
  },
  
  {
    id: 7,
    name: '辻 徹',
    role: '金網つじ 代表取締役社長／京金網職人',
    photo: './assets/winners/winners-07.webp',
    bio: '京金網を手がける「金網つじ」の2代目。針金を手編みする伝統技術を、セラミック付き焼き網やランプシェードなど現代の生活道具へ展開。同時に、直営店やオンライン販売にも注力し、従来の流通にとらわれず国内外の市場を開拓した。2012年には京都の伝統工芸の後継者らとクリエイティブユニット「GO ON」を立ち上げ。パナソニックやルイ・ヴィトンと協業して未来の家電やファッションにも応用した。従来は少なかった女性や、障がいのある人も職人として受け入れ、特性に応じて工程を設計。技術だけでなく担い手の裾野も広げている。',
  },
  
  {
    id: 8,
    name: '瀬川 公雄（AO）',
    role: 'Hypolygon 代表取締役／プロデューサー',
    photo: './assets/winners/winners-08.webp',
    bio: 'アパレルやゲームのデザイナーを経て、2024年にゲーム制作会社「Hypolygon」を設立。「Fortnite」や「Roblox」といった世界的人気のゲームプラットフォームを舞台に、企業・商品・人物の世界観 をゲーム化するプロモーションを手がける。アシックス、東映太秦映画村、HIKAKINなどと協業し、制作したゲーム作品の累計訪問者数は 2,000万人以上。広告を従来のよ うな一方的な情報表示ではなく、ユーザー自身が参加し、没入できる「遊び」に変換することで、既存の文化やブランドの世界観を新たな受け手へ届けている。',
  },
  
  {
    id: 9,
    name: '大澤 創太',
    role: 'NERD 代表取締役／クリエイティブディレクター',
    photo: './assets/winners/winners-09.webp',
    bio: '1996年生まれ。大学在学中にCHOCOLATE入社し、クリエイティブディレクターとしてSTARBUCKS COFFEE・たまごっち・Apple・NetflixをはじめとするグローバルブランドやIPの広告コミュニケーションに従事する。2026年3月に共同代表の髙橋政記とともにアーティストエージェンシーNERDを設立。星街すいせい、擬態するメタ、TAKU INOUE、神田百実、横山マサト、NIOをはじめとする、独自の創造性を持つインディペンデントなアーティストのプロデュースやマネジメントを手掛けながら、ナードカルチャーを起点としたブランド型の組織構築を目指す。',
  },
  
  {
    id: 10,
    name: '岩永 祐一',
    role: 'SAMANSA 代表取締役CEO',
    photo: './assets/winners/winners-10.webp',
    bio: '映画館経営者だった曽祖父の影響で幼いころから映画に親しみ、2021年にショート映画専門の配信サービス「SAMANSA」を創業。世界中に埋もれていた30分以下の作品を発掘し、独自に字幕や宣伝動画を制作することで、国や言語を超えて新たなニーズを喚起している。配信のみならず劇場公開や機内放映も展開し、収益化が難しかったショート作品クリエイターへの還元モデルを構築。「映画を、自由化する。」を掲げ、長編中心の映画産業においてショート映画を日常的に楽しむ視聴文化と、つくり手が継続的に制作・収益化できる経済圏を育てている。',
  },
  
  {
    id: 11,
    name: '伊藤 主税',
    role: 'and pictures 代表取締役／映画プロデューサー',
    photo: './assets/winners/winners-11.webp',
    bio: '俳優から映画プロデューサーに転身し映画製作会社「and pictures」を設立。俳優志望者向けの情報支援サービス「mirroRliar」や、著名クリエイターと公募で選ばれた新たな才能がともに参加する短編映画制作プロジェクト「MIRRORLIAR FILMS」を展開する。企業版ふるさと納税をはじめ、自治体や企業と連携した制作費の確保や、地域・クリエイターへの収益還元、学生や市民を巻き込んだ人材育成などを通じて、映画を「一部の専門家がつくる文化」から「多様な人が地域社会とともにつくる文化」へと更新している。',
  },
  
  {
    id: 12,
    name: '永井 真之',
    role: 'Visual Bank 代表取締役CEO／THE PEN 代表取締役',
    photo: './assets/winners/winners-12.webp',
    bio: '投資銀行勤務を経て、2022年に生成AI向けデータ基盤企業「Visual Bank」を共同創業。ストックフォト事業「アマナイメージズ」を取得し、長年培われた権利処理のノウハウを生かして著作権や肖像権に配慮した10億点に及ぶ画像と100万時間の動画データを提供する。その発想を漫画領域にも広げ、漫画家本人の作画データをAIに学習させ本人の画風で作画を補助する「THE PEN」を開発。「創造性の黒子」としてAI技術を用い、クリエイターの権利を守りながら、時間や体力の制約を減らして人が創作に集中できる環境をつくろうとしている。',
  },
  
  {
    id: 13,
    name: '宇田 英男',
    role: 'スタジオエイトカラーズ 代表取締役／ノーヴォ 代表取締役',
    photo: './assets/winners/winners-13.webp',
    bio: '『新世紀エヴァンゲリオン』シリーズで知られる 制作会社「カラー」で会計・管理を担当したの ち、東京で「スタジオコロリド」と「ノーヴォ」、 高知県内初の「スタジオエイトカラーズ」のア ニメ制作会社3社を創業。「誰が、どこで、どう つくるか」を問い直し、デジタル化で地方にも アニメーターの職場を創出した。OJT・インターンでの若手育成に加え、異業種人材の採用 で制作へのかかわり方を多様化。「東京中心」「アナログ作業」「職人的な人材育成」など業界が抱える課題に向き合い、日本の手描きアニメ技 術を次世代へつなぐ存在だ。',
  },
  
  {
    id: 14,
    name: '辻 雄貴',
    role: '華道家／辻雄貴空間研究所 代表',
    photo: './assets/winners/winners-14.webp',
    bio: '20代でいけばなを学び始め、華道家・竹中麗湖に師事。能楽師・大倉慶乃助と舞台作品「シャクジ能」を立ち上げたほか、華道家初となるNYカーネギーホールでの演技など、国内外でさまざまな空間表現に挑戦する。いけばなを「自然と人の関係を結び直す美学」と捉え、自然資源に文化的な価値へと変えて仕事や収益を生み、その利益を再び自然へ還元する「循環型アート」を提唱。2026年にはその実践の場として故郷・静岡に約1,500坪の山を購入し、放置林を再生しながら、そこで育つ植物を作品に用い、山を文化体験の場として活用する100年単位のプロジェクトに取り組む。',
  },
  
  {
    id: 15,
    name: '川原 隆邦',
    role: '和紙職人／川原製作所代表',
    photo: './assets/winners/winners-15.webp',
    bio: 'プロサッカー選手を目指してJFLでプレイするも、けがで断念。後継者不在で途絶えようとしていた地元・富山の蛭谷（びるだん）和紙の職人に弟子入りした。原料となる楮（こうぞ）やトロロアオイの栽培、紙すき、造形を一貫して手がけ、受注ごとに素材や表現を設計 する「フリースタイル和紙」を確立。建築・公 共空間・現代アートへ展開し、2025年大阪・関西万博では、土や植物、デニム、塩などをすき込んで日本の風土を表現した大型アート制作も担当した。現在唯一の継承者として、新たな用途と需要を生み出しながら蛭谷和紙を次代へつないでいる。',
  },
  
  {
    id: 16,
    name: '永田 宙郷',
    role: 'TIMELESS LLC. 代表／ててて協働組合 共同代表',
    photo: './assets/winners/winners-16.webp',
    bio: '金沢美術工芸大学で日本工芸史を学んだ後、美術館・デザインプロデュース会社に勤務。多くの地域・企業に携わる傍ら、2012年から「作り手・伝え手・使い手」の3つの「手」をつなぐ「ててて見本市」(現・ててて商談会)を仲間と共同主宰する。18年に個人事務所「TIMELESS」を設立。市場での位置づけや販路、誰にどう届けるかまでを見据え、金継ぎや織物など地域の伝統産業を背景にした事業立案を手がける。「ものづくりをつくる」を掲げ、工芸が現代の暮らしや経済のなかで持続可能な「仕事」として続くための仕組みづくりに取り組んでいる。',
  },
  
  {
    id: 17,
    name: '南條 和哉',
    role: '有限会社南條工房 七代目（南條勘三郎）／LinNe代表',
    photo: './assets/winners/winners-17.webp',
    bio: '江戸時代から続く鳴物鋳物（なりものいもの）の「南條工房」7代目。2003年に南條工房へ入社。約15年間工房に籠って腕を磨き、銅と錫（すず）の合金「佐波理」を用いた伝統技術を継承する。単体で鳴らせる小さな鈴型の「Chibi」を開発し、2019年に新ブランド「LinNe」を立ち上げた。瞑想やヨガ、ラグジュアリーホテルのトリートメントなど、仏具の枠を超えておりんの用途を拡大。従来の仏具の商流と技術も守りながら、200年受け継いだ音が心身に与える影響の解明にも取り組んでいる。',
  },
  
  {
    id: 18,
    name: '佐藤 貴彦',
    role: '佐藤喜代松商店 代表取締役',
    photo: './assets/winners/winners-18.webp',
    bio: '京都・西陣で1921年に創業した漆屋の4代目として、漆の精製・販売や漆製品の開発に携わる。大学院で応用昆虫学を専攻し、青年海外協力隊員としてエルサルバドルで活動後、家業へ。先代である実父が開発した耐候性や乾燥性に優れる「MR漆」の研究成果を異業種へとつなぎ、自動車への塗装はひときわ大きな反響を呼んだ。今年はISSEY MIYAKEとのコラボ商品「ウルシボディ」を手がけ、工業からファッションまで漆の活躍の場を広げている。透明感と光沢を高めた漆「黎明」を開発するなど、自らも研究開発を継続。顧客の課題に科学的なアプローチで応えながら、漆の新たな可能性を引き出している。',
  },
  
  {
    id: 19,
    name: '松場 忠',
    role: '石見銀山群言堂グループ 代表取締役',
    photo: './assets/winners/winners-19.webp',
    bio: 'シューズメーカー勤務を経て、石見銀山生活文化研究所で島根県大田市大森町のライフスタイルブランド「群言堂」の運営に携わる。「生活観光」を提唱し、宿泊客が町内を巡って住民と交流することで、地域の日常そのものを体験できる旅のかたちをつくった。2022年には創業者である義父母から経営を承継。企業誘致や働く場づくりを通じて人口約400人の町に移住者や新事業を呼び込み、人・仕事・経済が循環する環境を整える。「その土地の暮らしに混じる」という新たな滞在需要を生み出し、生活という無形の価値を地域経営へとつなげている。',
  },
  
  {
    id: 20,
    name: '小林 新也',
    role: '合同会社シーラカンス食堂 代表社員／MUJUN 代表',
    photo: './assets/winners/winners-20.webp',
    bio: '表具店を営む家庭に育ち、大阪芸術大学卒業後の2011年、兵庫県小野市でデザイン会社「シーラカンス食堂」を設立。地域の伝統産業を対象に、ブランドプロデュースから販路開拓、職人育成、事業承継までを手がける。地元の名産「播州そろばん」は、新商品開発や中東圏への販路開拓で新たな需要を生む一方、後継者育成や問屋のメーカー化を支援。「播州刃物」は欧州販路を開拓し、若手の職人を育てる「MUJUN WORKSHOP」を創設した。このほか、島根県温泉津では、職人同士が支え合って生業を営む村「MUJUN Planet」づくりを進め、手仕事が産業として続く環境を地域からつくっている。',
  },
  
  {
    id: 21,
    name: '山本 雅也',
    role: 'キッチハイク 代表取締役CEO',
    photo: './assets/winners/winners-21.webp',
    bio: '「食」と「地域」をテーマに、人と地域を深くつなぐ事業を展開する起業家。2012年にキッチハイクを創業し、食を起点に人と地域をつなぐサービスを手がけた後、コロナ禍を機に地域の食のブランディング事業へ軸足を移す。自身の子育て経験をもとに、北海道厚沢部町で「保育園留学」を立ち上げ、全国80以上の地域へ拡大。これまでに累計3,500家族、1万5千人以上が利用している。都市部の家族が地域で暮らし、子どもが現地の保育園に通う仕組みを通じて、関係人口や経済循環を生み出す。現在は厚沢部町に本社を移し、「やわらかな定住」という新たな暮らし方を提唱している。',
  },
  
  {
    id: 22,
    name: '豊田 訓平',
    role: 'HUB＆STOCK 代表取締役社長',
    photo: './assets/winners/winners-22.webp',
    bio: '新卒でゼネコンに入社し、建築現場で資材発注などを経験。大量の新品建材が未使用のまま廃棄される実態に問題意識を持ち、2021年にスタートアップ「HUB & STOCK」を創業した。国内で年間約40万トンにものぼる、発注時の余りや、廃番などで生じた新品未使用の建材を買い取り、検品・保管を経て再販。重くかさばるうえ品目や数量も異なる建材を、大量かつ継続的に流通させる仕組みを構築している。施工事例の紹介などで新たな魅力や用途も提案。「もったいない」に経済合理性と楽しさを掛け合わせ、物を大切にする文化を現代へつなぎ直している。',
  },
  
  {
    id: 23,
    name: '齋藤 由佳子',
    role: 'JIEN LLP 共同代表／土壌回復コンソーシアム JINOWA代表',
    photo: './assets/winners/winners-23.webp',
    bio: '日伊を拠点に「土」を起点とした食、農、発酵、建築などを横断するプロジェクトを企画し、日本の地域の知恵を世界とつなぐ。イタリアで2014年に食文化教育ベンチャーGENを創業し、食や建築分野で30カ国以上から研修生を日本各地に受け入れてきた。「土はすべての産業の共通基盤」として、21年に土壌回復コンソーシアム「JINOWA」、23年には建築家・遠野未来氏とJIEN LLPを共同設立。循環型バイオトイレの監修など生態系を再生するリワイルディングデザインや、土壌再生を地域経済へつなげるエコシステムづくりに挑む。',
  },
  
  {
    id: 24,
    name: '高山 健太郎',
    role: 'artness 代表取締役／GO FOR KOGEI 共同キュレーター',
    photo: './assets/winners/winners-24.webp',
    bio: '直島福武美術館財団（現・福武財団）で豊島美術館や瀬戸内国際芸術祭の始動など、約17年にわたり文化芸術の現場に携わる。2021年に文化事業会社「artness」を設立。日本初の文化芸術分野特化型ジョブフェア「ART JOB FAIR」を東京で立ち上げ、求職者と採用側が直接出会える場を創出。人脈頼みの採用慣行に突破口をつくった。今年は京都で伝統産業など文化全般へ対象を広げた「CULTURAL JOB FAIR」も展開予定。文化を担う人材の支援や持続的に働ける環境づくりを事業化し、文化継承の土壌を築いている。',
  },
  
  {
    id: 25,
    name: '今井 翔也',
    role: 'LINNÉ 代表取締役／醸造家',
    photo: './assets/winners/winners-25.webp',
    bio: '群馬の老舗蔵元「聖（ひじり）酒造」に生まれ、企業勤務を経て酒づくりの道へ。日本酒に果物やハーブを取り入れて再解釈する「クラフトサケ」のスタートアップ「WAKAZE」を共同創業し、仏・米で醸造経験を積んだ。2024年創業の「LINNÉ」では「麹＝米」という日本酒の常識を問い直し、大麦やそば、サツマイモなどを麹にして醸す「クロスボタニカル」を探求している。来春には国内外の醸造家が利用できるシェア型醸造所を京都・五条坂に開設予定。「何を加えるか」から「何からつくるか」へと発想を広げ、新たな酒文化を切り開いている。',
  },
  
  {
    id: 26,
    name: '新古 敏朗',
    role: '湯浅醤油 代表取締役／丸新本家 五代目当主',
    photo: './assets/winners/winners-26.webp',
    bio: '家業は醤油発祥の地とされる和歌山県湯浅町で約145年続く味噌・醤油蔵。約40年間途絶えていた醤油醸造を復活させ、2002年に「湯浅醤油」を新設した。杉の木桶を用いた伝統 製法を受け継ぎ、小学生への食育活動に励む一方、仏ボルドーでワインだるを用いて現地醸造した「SHINKO NOIRE」や、発酵技術をカカオに応用した「カカオ醤」など、新たな醤油づくりにも挑戦。来年には民間宇宙ステーションに滞在させた麹菌で醤油を仕込む実験も計画している。日本固有の醸造技術を、あらゆる場所で育つ発酵文化へと進化させている。',
  },
  
  {
    id: 27,
    name: '米津 雄介',
    role: 'THE 代表取締役／プロダクトマネージャー',
    photo: './assets/winners/winners-27.webp',
    bio: '2012年に日用品ブランド「THE」の立ち上げに参画し、15年代表取締役に就任。生分解性に配慮した「THE 洗濯洗剤」や、青森のガラス職人と開発した液だれしにくい「THE 醤油差し」など、身近な生活用品を形状・歴史・機能・素材・環境負荷から見直し、全国各地のメーカーとともに商品化している。25年には国際認証「B Corp」を取得。蓄積されたものづくりの技術を生かすことで、新奇性や差別化を競った新商品を次々と消費する文化に対して、長く使える「定番」を選ぶという新たな価値観を提示。「モノを捨てない社会」を日用品から実現しようとしている。',
  },
  
  {
    id: 28,
    name: '菊地 あかね',
    role: '所作研究家／KiQ Founder & CEO',
    photo: './assets/winners/winners-29.webp',
    bio: '18歳で渡米し、NYでデジタルデザインを学ぶ。海外生活を機に日本文化への関心を深め、帰国後は東京で芸者修行を経験。茶道や華道、上方舞なども学ぶ。2020年にデザインファーム「KiQ（キク）」を設立し、視線や体の距離、動くタイミングなどを「所作学（Shosa-logy）」として研究している。大阪・関西万博では、ロボット工学の第一人者・石黒浩が手がけたパビリオンで全ヒューマノイドの所作とコンセプトを設計。日本文化のなかで培われてきた自然な動作の美しさを抽出し、AI時代における人と機械のかかわり方を探究している。',
  },
  
  {
    id: 29,
    name: '上林 央佑',
    role: '京都染元しょうび苑3代目／Textile Director',
    photo: './assets/winners/winners-30.webp',
    bio: '布に染み込ませた蝋（ろう）の亀裂から独特の線模様を生む伝統技法「ろうけつ染め」を継承する染色工房の3代目。大学在学中にシリコンバレーで起業家の事業支援に従事。帰国後は現地で培った知見や人脈を生かして家業の海外展開を担い、主力ののれんを中心に世界15カ国へと販路を拡大した。仏五つ星ホテルや世界的メゾンへの納入実績をもつほか、ろうけつ染め壁紙や欧州デザイナーと協業開発したブラインドなど、ファッションやインテリアへも用途を開拓。複数の伝統技術を事業として存続させる「伝統産業発のコングロマリット」構想も掲げている。',
  },
];

// ── Advisory ────────────────────────────────────────────────────────────────
export const ADVISORY: PersonData[] = [
  {
    id: 0,
    name: '齋藤 峰明',
    role: 'シーナリーインターナショナル代表／エルメス パリ本社 元副社長',
    photo: './assets/advisory/advisory-01.webp',
    bio: 'パリ第一大学芸術学部卒業。三越パリ駐在所長を経てエルメスに入社。1998年エルメスジャポン社長、2008年には外国人初のパリ本社副社長に就任。15年に退社後、シーナリーインターナショナルを設立。現在は企業や自治体のブランド戦略、日本の伝統産業や地域再生の支援に取り組む。',
  },
  {
    id: 1,
    name: '松本 淳',
    role: '専修大学文学部教授／NPO法人 ANiC 理事長',
    photo: './assets/advisory/advisory-02.webp',
    bio: 'ジャーナリストとしてITmediaなどでアニメ・マンガのビジネス領域を取材・執筆。研究者とジャーナリストを兼任しながら、次世代人材の育成に取り組む。コンテンツ産業の新たなエコシステム構築やイノベーション推進をライフワークとし、産業の持続的な発展を支える活動を続けている。',
  },
  {
    id: 2,
    name: '川邊 健太郎',
    role: 'LINEヤフー前代表取締役会長',
    photo: './assets/advisory/advisory-03.webp',
    bio: '1974年生まれ。青山学院大学在学中に起業し、2000年ヤフー入社。Yahoo!ニュース、GYAOなどを牽引。18年に社長CEO、23年にLINEヤフー会長に就任。政府の「新しい資本主義実現会議」委員も務めた。26年の退任後はAIソロプレナーとして新たな事業創出に挑む。',
  },
  {
    id: 3,
    name: '古市 奏文',
    role: '社会変革推進財団（SIIF）事業部／インパクト・カタリスト',
    photo: './assets/advisory/advisory-04.webp',
    bio: 'インパクト投資やシステムチェンジを実践。近年、地域に眠る風土、歴史、技術、物語などを「文化資本」ととらえ、投資や事業、地域開発へ接続。文化的インパクトの評価や基金設計、事業創出など、金融・文化・クリエイティブを横断し、文化を未来をつくる資本へ変える仕組みを探究する。',
  },
  {
    id: 4,
    name: '日比野 克彦',
    role: 'アーティスト、東京藝術大学長',
    photo: './assets/advisory/advisory-05.webp',
    bio: '1958年、岐阜県生まれ。東京藝術大学大学院修了。80年代から段ボールなど身近な素材を用いた作品で注目を集め、国内外で発表。各地で地域の人々と協働するアートプロジェクトにも取り組んでいる。2022年より東京藝術大学長を務める。',
  },
  {
    id: 5,
    name: '秋元 雄史',
    role: '美術評論家／東京藝術大学名誉教授',
    photo: './assets/advisory/advisory-06.webp',
    bio: '1955年、東京都生まれ。東京藝術大学美術学部絵画科卒。91年からベネッセアートサイト直島に携わり、地中美術館館長、金沢21世紀美術館館長、東京藝術大学大学美術館館長・教授などを歴任。現代美術や工芸の展覧会を国内外で数多く手がけ、地域とアートを結ぶ活動も続ける。',
  },
  {
    id: 6,
    name: '宮田 人司',
    role: 'MISTLETOE代表／クリエイター・起業家',
    photo: './assets/advisory/advisory-07.webp',
    bio: '音楽家として活動後、1989年に起業。デジタルコンテンツや着メロ事業を手がけ、2010年に金沢へ移住。現在はスタートアップへの投資・支援のほか、食、アニメーション、地域文化など領域を横断して活動。OPENSAUCE、Tonko House、secca、甍酒蔵などのファウンダー。',
  },
  {
    id: 7,
    name: '廣瀬 理子',
    role: '日本たばこ産業 D-LAB ディレクター',
    photo: './assets/advisory/advisory-08.webp',
    bio: '1991年、京都府生まれ。2015年JT入社。新規事業の立ち上げ、人事領域、事業企画を経て投資・M&Aに従事。24年から「ALTERNATIVE LUXURY」を掲げ、文化・自然資本を核とした投資活動を推進。現在は文化資本の探究と、新たな事業への接続に取り組む。',
  },
  {
    id: 8,
    name: '大西 洋',
    role: 'SBI地方創生クリエイターズ代表取締役社長',
    photo: './assets/advisory/advisory-09.webp',
    bio: '1979年慶應義塾大学商学部卒業後、伊勢丹入社。店舗開発や海外勤務を経て新宿本店メンズ館のリモデルを主導。三越伊勢丹HD社長などを経て、2019年より羽田未来総合研究所社長。26年に退任。5月、SBI地方創生クリエイターズ社長に就任し、地域資源を生かした事業創出に取り組む。',
  },
  {
    id: 9,
    name: '岩本 涼',
    role: 'TeaRoom 代表取締役CEO／茶道裏千家準教授',
    photo: './assets/advisory/advisory-10.webp',
    bio: '1997年生まれ。幼少期に茶道裏千家へ入門。早稲田大学在学時の2018年、TeaRoomを創業。静岡県の茶工場を承継し、一次産業から事業に参入。抹茶の国際団体International Matcha Association代表理事、中川政七商店、三谷産業社外取締役。',
  },
  {
    id: 10,
    name: '中川 淳',
    role: 'VISION to STRUCTURE代表／2026年度グッドデザイン賞審査員長',
    photo: './assets/advisory/advisory-11.webp',
    bio: '1974年、奈良県生まれ。京都大学法学部卒業後、2002年中川政七商店に入社。08年に十三代社長、18年には会長に就任し、工芸業界初となるSPA業態を確立。25年に同社会長を退任。現在は企業のビジョンと、そのビジョンを基点とした競争戦略の策定を支援している。',
  },
  {
    id: 11,
    name: '北川 淑恵',
    role: '季縁 代表取締役',
    photo: './assets/advisory/advisory-12.webp',
    bio: '伝統工芸・アート・ファッション・観光領域で、文化とビジネスを掛け合わせた事業・プロジェクトを多数手がける。2020年に着物アップサイクルの事業、季縁を設立。24年よりCOBI代表取締役として、日本文化とラグジュアリーを軸に新たな学びの体験を創出している。',
  },
  {
    id: 12,
    name: '栗林 和明',
    role: 'CHOCOLATE 取締役CCO／クリエイティブディレクター',
    photo: './assets/advisory/advisory-13.webp',
    bio: 'JAAAクリエイターオブザイヤー最年少メダリスト。カンヌライオンズ、スパイクスアジア、メディア芸術祭、ACCなど、国内外のアワードで60以上の受賞。さまざまなエンターテイメントの知恵を越境・融合させ、映像や広告、商品開発まで幅広く、新しいつくり方を実践している。',
  },
  {
    id: 13,
    name: '杉山 央',
    role: 'Art+Tech Producer',
    photo: './assets/advisory/advisory-14.webp',
    bio: '2024年に新領域を設立。25年大阪・関西万博「いのちのあかし」計画統括ディレクター、26年「TOKYO CREATIVE SALON」統括ディレクター、27年開催予定の「GREEN×EXPO」テーマ館展示ディレクターを務める。アートとテクノロジーを横断し、体験と空間を創造する。',
  },
  {
    id: 14,
    name: '佐宗 邦威',
    role: 'BIOTOPE シニアフェロー／戦略デザイナー',
    photo: './assets/advisory/advisory-15.webp',
    bio: '東京大学法学部卒、イリノイ工科大学デザイン研究科修了。P&Gでマーケティング、ソニーで新規事業創出に携わった後、2015年にBIOTOPEを創業。企業や組織の未来構想を支援する。著書に『直感と論理をつなぐ思考法』『ジャパン・アズ・オンリーワン』など。',
  },
  {
    id: 15,
    name: '石原 龍太郎',
    role: 'Culturepreneur Collectives 代表理事',
    photo: './assets/advisory/advisory-16.webp',
    bio: 'DeNA、Forbes JAPANで編集者を務めた後、BIOTOPEに参画。現在はManaging Partnerとして、企業や組織の文化醸成やブランディング、広報・PRを手がける。2023年、文化と経済の好循環を目指し、一般社団法人Culturepreneur Collectivesを設立。',
  },
  {
    id: 16,
    name: '中山 淳雄',
    role: 'エンタメ社会学者',
    photo: './assets/advisory/advisory-17.webp',
    bio: 'Re entertainment代表、日本大学芸術学部特任教授。リクルート、DeNA、コンサル会社を経て、バンダイナムコスタジオ、ブシロードで、メディアミックスIPプロジェクトの推進やアニメ・ゲーム・スポーツの海外展開を担当。コンテンツの海外展開をライフワークとする。',
  },
  {
    id: 17,
    name: '細尾 真孝',
    role: 'HOSOO代表取締役社長',
    photo: './assets/advisory/advisory-18.webp',
    bio: '1688年より織物業を営む西陣織の老舗「細尾」の十二代目。音楽活動や大手ジュエリーメーカーでの経験を経て、2008年に家業に入社。10年に世界初となる150cm幅の西陣織織機を開発し、新しいテキスタイルで世界的ラグジュアリーブランドと協業。一般社団法人GO ON 代表理事。',
  },
  {
    id: 18,
    name: '阿座上 陽平',
    role: 'ゼブラアンドカンパニー共同創業者／代表取締役',
    photo: './assets/advisory/advisory-19.webp',
    bio: '早稲田大学商学部卒。メディア企業、デジタルエージェンシー、メーカー勤務などを経て、2021年にZebras and Companyを共同創業。マーケティングやブランディング、ストーリーテリングを通じ、社会課題の解決と事業成長の両立を目指す企業の経営支援に取り組む。',
  },
];
